export const SET_TOAST = 'SET_TOAST';
export const CLEAR_TOAST = 'CLEAR_TOAST';
